module.exports = __webpack_public_path__ + "static/media/test11_1.730270e3.png";